import React, { useEffect, useRef } from "react";

function isNumber(value) {
  const conv = +value;
  if (conv && value > 0) {
    return true;
  }
  return false;
}

function OnceHubSnippet({ fields }) {
  const divRef = useRef();

  const { divId, dataSoPage, dataHeight } = fields;

  // check if dataHeight exists and is a positive number
  const isNum = dataHeight && isNumber(dataHeight.value);

  const htmlString = `<div id=${divId.value} data-so-page=${dataSoPage.value} ${
    isNum ? `data-height=${dataHeight.value}` : ""
  } data-style="border: 1px solid #d8d8d8; min-width: 290px; max-width: 900px;" data-psz="00"></div>
<script type="text/javascript" src="https://cdn.oncehub.com/mergedjs/so.js"></script>`;

  useEffect(() => {
    const fragment = document
      .createRange()
      .createContextualFragment(htmlString);
    divRef.current.append(fragment);
  }, []);

  return <div className="cm-rich-text" ref={divRef} />;
}

export default OnceHubSnippet;
